import React from 'react';
import classNames from 'classnames';
import { view } from 'react-easy-state';
import Store from '../store/store';
import PrestSearch from './PrestSearch';
import PrestName from './PrestName';
import PrestSceltaStruttura from './PrestSceltaStruttura';
import PrestShowStruttura from './PrestShowStruttura';

class PrestChoice extends React.Component {
  onScegliStruttura = (e) => {
    const { idx } = this.props;
    const { setStruttura } = Store;
    const val = e.target.value;

    setStruttura(idx, val);
  }
  
  downloadPdf = () => {
    const { idx } = this.props;
    const { prestazioni } = Store;
    const prest = prestazioni[idx];

    window.open(prest.preparazione, '_blank');
  }

  render() {
    const { idx, onClickModifica } = this.props;
    const { 
      prestazioni, 
      showSceltaStruttura,
      showInstaSearch,
      showStruttura,
      showDownloadPdfBtn
    } = Store;

    const prestazione = prestazioni[idx];

    const contClasses = classNames({
      'kfpr-cont': true,
      'kfpr-cont-prest': !Store.isSent
    });

    return (
      <div className={contClasses}>
          <div className="kfpr-row kfpr-row-head"> 
            <PrestName idx={idx} onClick={onClickModifica} />
            {
              showStruttura(idx) &&
              <PrestShowStruttura prestazione={prestazione} />
            }
          </div> 
            
          {
            showInstaSearch(idx) &&   
            <div className="kfpr-content kfpr-content-scegliprest">  
                <PrestSearch idx={idx} />
            </div>
          } 

          {
            showSceltaStruttura(idx) && 
            <PrestSceltaStruttura onClick={this.onScegliStruttura} />   
          }

          {
            showDownloadPdfBtn(idx) &&
            <div className="button big" role="button" onClick={this.downloadPdf}>Scarica Pdf</div>
          }
      </div>
    )
  }
}

export default view(PrestChoice);
